export type ChargeVerificationCheckboxViewModelInput = {
  canEdit: boolean;
  savedValue: boolean | undefined;
  stagedValue: boolean | undefined;
};

export type ChargeVerificationCheckboxViewModel = {
  isVisible: boolean;
  isDisabled: boolean;
  isChecked: boolean;
  hasPendingChange: boolean;
};

export function createChargeVerificationCheckboxViewModel({
  canEdit,
  savedValue,
  stagedValue,
}: ChargeVerificationCheckboxViewModelInput): ChargeVerificationCheckboxViewModel {
  const isVisible = savedValue !== undefined;
  const isChecked = stagedValue ?? savedValue ?? false;
  const hasPendingChange =
    isVisible && stagedValue !== undefined && stagedValue !== savedValue;

  return { isVisible, isDisabled: !canEdit, isChecked, hasPendingChange };
}
